import api from '@/utils/api';
import {
    LOOKUP_CUSTOMERS,
} from './types';
import { NotificationManager } from 'react-notifications';

export const lookupCustomers = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/lookup-customers', { params: filter }).then(res => {
            dispatch({
                type: LOOKUP_CUSTOMERS,
                payload: res.data.data
            });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}